export var defaultStepsProps = {
    className: '',
    direction: 'horizontal',
    current: -1,
    status: 'process',
    size: 'normal',
    onChange: function (current) { },
    onBeforeChange: function () { return true; },
};
export var defaultStepProps = {
    title: '',
    icon: '',
    description: '',
    className: '',
    disabled: false,
    status: '',
};
